<template>
    <div id="chatWrap">
        <div class="searchdiv">
            <a @click="searchOnlineUser">在线用户查询</a>
            <a @click="searchAllUser">所有用户查询</a>
        </div>
        <input type="hidden" id="fromUser" />
        <ul id="con">
            <li id="city" ref="city" class="show" v-html="cityContent"></li>
            <li id="world" ref="world" v-html="worldContent"></li>
            <li id="trade" ref="trade" v-html="tradeContent"></li>
            <li id="whisper" ref="whisper" v-html="whisperContent"></li>
            <li id="system" ref="system" v-html="systemContent"></li>
        </ul>
        
        <form id="sangForm" @submit.prevent="talk">
            <div class="chat-controls">
              <div class="func">
                <span id="lock" :class="lockClass" @click="lockit();">{{lockStr}}</span>
                <select id="msgType" name="msgType" @change="changeMsgType()">
                    <option value="城市">城市</option>
                    <option value="世界">世界</option>
                    <option value="交易">交易</option>
                    <option value="私聊">私聊</option>
                </select>
                <!-- 聊天动作图鉴：就地弹窗，不离开游戏界面；列表走公开接口，未登录也能看 -->
                <button type="button" class="mv-help" @click="openChatMovement"
                   title="聊天动作图鉴">?</button>
              </div>
              <div id="tit">
                <span
                    v-for="tab in tabs"
                    v-bind:key="tab"
                    v-bind:class="[{ select: currentTab === tab }]"
                    v-on:click="titit(tab)"
                >{{tab}}</span>
              </div>
            </div>
            <input class="typeIn" type="text" id="text" name="text" ref="chattext" v-model="chattext"/>
            <input class="button" type="button" @click="talk" value="发送"/>
        </form>
        
        <!-- 所有用户查询 -->
        <el-dialog class="wrap" :visible.sync="searchAllUserVisible" :before-close="search_all_user_dialog_close" append-to-body>
            <div class="searchUserbg">
                <div class="searchUserTitle">
                    所有用户查询
                </div>
                <div class="userSearch">
                    <label>用户名：</label>
                    <input type="text" v-model="userName"/>
                    <label>昵称：</label>
                    <input type="text" v-model="nickName"/>
                </div>
                <div v-if="null != fantasyUserBOList" class="fantasyUserBOList">
                    <el-row>
                    <el-col :span="6"><span>用户名</span></el-col>
                    <el-col :span="6"><span>昵称</span></el-col>
                    <el-col :span="12"><span>操作</span></el-col>
                    </el-row>
                    <div v-for="fantasyUser in fantasyUserBOList" v-bind:key="fantasyUser.id" :id="fantasyUser.id + '_user'">
                    <el-row>
                        <el-col :span="6"><span>{{fantasyUser.userName}}</span></el-col>
                        <el-col :span="6"><span>{{fantasyUser.nickName}}</span></el-col>
                        <el-col :span="12">
                            <span>
                                <a @click="whisperTo(fantasyUser.userName)">私聊</a>&nbsp;
                                <a @click="addFriendById(fantasyUser.id, fantasyUser.userName)">加好友</a>&nbsp;
                                <a @click="getDetail(fantasyUser.userName)">情报</a>
                            </span>
                        </el-col>
                    </el-row>
                    </div>
                    <div class="pageDiv">
                    <!-- 分页组件 -->
                    <Paging 
                        :name="name"
                        @change="onPageChange"
                        :page-size="size"
                        :total="total"
                        layout="jumper,total"
                        :current-page="curPage"
                    />
                    </div>
                </div>
                <div class="noUser" v-if="null == fantasyUserBOList">
                    未查询到用户，请修改后重试
                </div>
                <div style="clear:both"></div>
            </div>
        </el-dialog>

        
        <!-- 在线用户查询 -->
        <el-dialog class="wrap" :visible.sync="searchOnlineUserVisible" :before-close="search_online_user_dialog_close" append-to-body>
            <div class="searchUserbg">
                <div class="searchUserTitle">
                    最近20名在线用户
                </div>
                <div class="userSearch">
                    <label>用户名(精确查询)：</label>
                    <input type="text" v-model="onlineUserName"/>
                    <el-button size="mini" @click="checkAndGetDetail(onlineUserName)" type="primary">查看</el-button>
                </div>
                <div v-if="null != onlineUserList" class="fantasyUserBOList">
                    <el-row>
                    <el-col :span="12"><span>用户名</span></el-col>
                    <el-col :span="12"><span>操作</span></el-col>
                    </el-row>
                    <div v-for="onlineUser in onlineUserList" v-bind:key="onlineUser" :id="onlineUser + '_user'">
                    <el-row>
                        <el-col :span="12"><span>{{onlineUser}}</span></el-col>
                        <el-col :span="12">
                            <span>
                                <a @click="whisperTo(onlineUser)">私聊</a>&nbsp;
                                <a @click="addFriendByUserName(onlineUser)">加好友</a>&nbsp;
                                <a @click="getDetail(onlineUser)">情报</a>
                            </span>
                        </el-col>
                    </el-row>
                    </div>
                </div>
                <div style="clear:both"></div>
            </div>
        </el-dialog>

        
        <!-- 用户情报 -->
        <el-dialog class="detailwrap" :visible.sync="userDetailVisible" :before-close="user_detail_dialog_close" append-to-body>
            <div class="detailbg">
                <hr color="0080ff">
                <el-row>
                    <el-col :span="8">
                        <div id="header_div">
                            <div id="header_type" ref="header_type">
                            </div>
                            <div id="eye_type" ref="eye_type">
                            </div>
                            <div id="mouth_type" ref="mouth_type">
                            </div>
                            <div id="hair_type" ref="hair_type">
						</div>
					</div>
                    </el-col>
                    <el-col :span="16">
                        <div class="detailTitle">基本资料：</div>
                        <div>
                            <span class="detailLabel">用户名：</span>
                            <span class="detailValue">{{fantasyUser.userName}}</span>
                        </div>
                        <div>
                            <span class="detailLabel">昵称：</span>
                            <span class="detailValue">{{fantasyUser.nickName}}</span>
                        </div>
                        <div>
                            <span class="detailLabel">上站次数：</span>
                            <span class="detailValue">{{fantasyUserDetail.logintimes}}</span>
                        </div>
                        <div>
                            <span class="detailLabel">上站时间：</span>
                            <span class="detailValue">{{fantasyUserDetail.landingtime | formatLandingTime}}</span>
                        </div>
                        <div>
                            <span class="detailLabel">简介：</span>
                            <span class="detailValue" :title="fantasyUser.remark">
                                {{fantasyUser.remark}}
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <hr color="0080ff">
                <div class="detailTitle">社区经验：</div>
                <el-row>
                    <el-col :span="8"><span class="detailLabel">经验：</span></el-col>
                    <el-col :span="16"><span class="detailValue">{{fantasyUserDetail.exp}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="8"><span class="detailLabel">等级：</span></el-col>
                    <el-col :span="16"><span class="detailValue">{{fantasyUserDetail.level}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="8"><span class="detailLabel">称号：</span></el-col>
                    <el-col :span="16"><span class="detailValue">{{fantasyUserDetail.chenghao}}</span></el-col>
                </el-row>
            </div>
        </el-dialog>

        <!-- 聊天动作图鉴：就地弹窗，查语法不用离开游戏界面。
             列表复用独立页的 ChatMovementList 组件（compact 紧凑版），
             接口 /chat/chatMovement/list 是公开的，未登录也能看。 -->
        <el-dialog class="mv-dialog" :visible.sync="chatMovementVisible" append-to-body width="760px">
            <div class="mv-panel">
                <div class="mv-title">聊天动作图鉴</div>
                <div class="mv-tip">
                    聊天框输入 <code>~</code> 加别名即可做动作，例如 <code>~大笑</code>、<code>~daxiao</code>、<code>~laugh</code> 效果一样；
                    想指定对象就再跟一个空格和对方昵称，例如 <code>~大笑 wang</code>。
                </div>
                <div class="mv-roles">
                    <label>预览用我的名字 <input v-model="mvMe" maxlength="12" /></label>
                    <label>对方名字 <input v-model="mvTarget" maxlength="12" /></label>
                    <span class="mv-note">只影响预览，不影响游戏</span>
                </div>
                <div class="mv-legend">
                    <span><i style="background:#ff8800"></i>发起者 / 你自己</span>
                    <span><i style="background:#0088ff"></i>被指定的对象</span>
                    <span><i style="background:#888888"></i>旁观者视角的叙述</span>
                </div>
                <chat-movement-list :me-name="mvMe" :target-name="mvTarget" compact />
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {postRequest} from '../utils/api'
    import {getRequest} from '../utils/api'
    import Paging from '../components/Paging';
    import {formatDateTime} from '../utils/filter_utils'
    import {chatUrl} from '../utils/api'
    import SockJS from "sockjs-client"
    import Stomp from "stompjs"
    import $ from 'jquery'
    import Vue from 'vue'
    import { clearInterval } from 'timers';
    import { Message } from "element-ui"
    import { stringify } from 'querystring';
    Vue.prototype.timer1 = null
    
    export default {
        components:{
            Paging,
            // 聊天动作图鉴列表：懒加载，只有点开「?」弹窗才拉这个 chunk，
            // 不拖累首屏（与 2026-10-03 的首屏瘦身保持一致）。
            ChatMovementList: () => import(/* webpackChunkName: "chat-movement" */ './chatMovement/ChatMovementList.vue')
        },
        data() {
            return {
                lockScroll: false,
                lockClass: '',
                lockStr: '锁',
                fromUser: '',
                stomp: null,
                currentTab: '城',
                tabs: ['城', '世', '交', '私', '系'],
                currentUser: null,
                talkableWorld: true,
                talkableCity: true,
                talkableTrade: true,
                talkableWhisper: true,
                hiddenTime: null,
                cityContent: "",
                worldContent: "",
                tradeContent: "",
                whisperContent: "",
                systemContent: "",
                chattext:"",
                msg: '',
                name:'',
                size:10,
                total:0,
                curPage:1,
                searchAllUserVisible: false,
                userName: "",
                nickName: "",
                fantasyUserBOList: [],
                searchOnlineUserVisible: false,
                onlineUserList: [],
                onlineUserName: "",
                fantasyUser: {},
                fantasyUserDetail: {},
                userDetailVisible: false,
                whisperUser: "",
                fantasyUserHeader: {},
                // 聊天动作图鉴弹窗（列表数据由 ChatMovementList 自己拉，走公开接口）
                chatMovementVisible: false,
                mvMe: '',
                mvTarget: 'wang',
                // 触摸设备（无hover）标识，用于点击昵称切换私聊/情报菜单
                isTouch: window.matchMedia ? window.matchMedia('(hover: none)').matches : window.innerWidth <= 768,
            };
        },
        watch: {
            userName: {
                handler(newVal, oldVal) {
                    if (newVal != null) {
                        this.userName = newVal;
                        this.searchAllUser();
                    }
                }
            },
            nickName: {
                handler(newVal, oldVal) {
                    if (newVal != null) {
                        this.nickName = newVal;
                        this.searchAllUser();
                    }
                }
            },
            cityContent() {
                this.$nextTick(() => {
                    this.keepBottom(this.$refs.city);
                })
            },
            worldContent() {
                this.$nextTick(() => {
                    this.keepBottom(this.$refs.world);
                })
            },
            tradeContent() {
                this.$nextTick(() => {
                    this.keepBottom(this.$refs.trade);
                })
            },
            whisperContent() {
                this.$nextTick(() => {
                    this.keepBottom(this.$refs.whisper);
                })
            },
            systemContent() {
                this.$nextTick(() => {
                    this.keepBottom(this.$refs.system);
                })
            }
        },
        mounted: function () {
            document.querySelector('#con').addEventListener('touchstart', function () { }, false);
            // 事件委托绑定到 document，避免 #con 节点被重建后监听器失效
            document.addEventListener('click', this.chatClickHandler, false);
            this.disconnect();
            //手机屏幕关闭后会造成退出聊天，加上下面这句，看看是否能解决
            //this.connect();
            this.$root.eventHub.$on('currentUser', this.connect);
            // 跨城（王都 ⇄ 幻之都）：城市频道内容必须隔离，切城时清空并重拉新城市消息
            this.$root.eventHub.$on('cityInfo', this.onCityInfo);
            // 街道玩家情报卡的动作：私聊 / 加好友（卡片本身只管展示，动作归聊天区）
            this.$root.eventHub.$on('whisperTo', this.whisperTo);
            this.$root.eventHub.$on('addFriend', this.handleAddFriendEvent);
        },
        created: function () {
            // 当前所在城市 id（非响应式，仅用于判断是否跨城）
            this._cityId = null;
            document.addEventListener('visibilitychange', this.reconnect, false);
        },
        beforeDestroy: function () {
            document.removeEventListener('click', this.chatClickHandler, false);
            this.disconnect();
            this.$root.eventHub.$off('currentUser', this.connect);
            this.$root.eventHub.$off('cityInfo', this.onCityInfo);
            this.$root.eventHub.$off('whisperTo', this.whisperTo);
            this.$root.eventHub.$off('addFriend', this.handleAddFriendEvent);
            document.removeEventListener('visibilitychange', this.reconnect, false);
        },
        methods: {
            /* ── 聊天动作图鉴弹窗 ──────────────────────────────
               首次打开用玩家自己的昵称做预览名（未登录/取不到则退回示例名）；
               之后保留玩家手改过的值，不每次覆盖。 */
            openChatMovement() {
                if (!this.mvMe) {
                    this.mvMe = (this.currentUser && this.currentUser.nickName) || '星尘';
                }
                this.chatMovementVisible = true;
            },
            reconnect() {
                var _this = this;
                if(document.visibilityState=='hidden') {
                    this.hiddenTime = new Date().getTime()	//记录页面隐藏时间
                }else{
                    let visibleTime = new Date().getTime();
                    if((visibleTime - this.hiddenTime) / 1000 > 10){	//页面再次可见的时间-隐藏时间>10S,重连
                        this.disconnect();    //先主动关闭连接
                        console.log('主动关闭连接后重连');
                        //手机屏幕点亮后重新链接
                        this.stomp = null;
                        setTimeout(function(){
                            _this.connect(_this.currentUser)    //打开连接
                        },1500);    //1.5S后重连
                    }
                }
            },
            search_online_user_dialog_close() {
                this.searchOnlineUserVisible = false;
            },
            // 关闭所有昵称操作菜单（清空inline样式，恢复CSS默认隐藏）
            closeAllNicknameOpts() {
                var list = document.querySelectorAll('#con .nickname .opts');
                for (var i = 0; i < list.length; i++) {
                    list[i].style.display = '';
                }
            },
            // 聊天区域统一点击处理（绑定在 document 上，兼容 #con 节点被重建的场景）
            chatClickHandler(event) {
                var target = event.target;
                // 非聊天区域：触摸设备关闭昵称菜单
                if (!target.closest || !target.closest('#con')) {
                    if (this.isTouch) {
                        this.closeAllNicknameOpts();
                    }
                    return;
                }
                // 触摸设备：点击昵称切换私聊/情报菜单，点击其他区域关闭
                if (this.isTouch) {
                    var nickSpan = target.closest('.nickname');
                    if (nickSpan) {
                        var opts = nickSpan.querySelector('.opts');
                        if (opts) {
                            var alreadyShow = opts.style.display === 'block';
                            this.closeAllNicknameOpts();
                            if (!alreadyShow) {
                                opts.style.display = 'block';
                            }
                        }
                    } else {
                        this.closeAllNicknameOpts();
                    }
                }
                if ("A" == target.tagName) {
                    var dataset = target.dataset || {};
                    var username = dataset.username;
                    if ("私聊" == target.text) {
                        if (!username) return;
                        this.chattext = "/" + username + " ";
                        this.whisperUser = username;
                        this.$refs['chattext'].focus();
                    } else if ("情报" == target.text) {
                        if (!username) return;
                        this.getDetail(username);
                    }
                }
            },
            user_detail_dialog_close() {
                this.userDetailVisible = false;
            },
            search_all_user_dialog_close() {
                this.searchAllUserVisible = false;
            },
            onPageChange:function(page){
                this.curPage = page.curPage;
                this.searchAllUser();
            },
            searchOnlineUser() {
                this.searchOnlineUserVisible = true;
                this.onlineUserList = [];
                this.userName = "";
                this.nickName = "";
                this.onlineUserName = "";
                var _this = this;
                getRequest('/user/user/searchOnlineUserList', {
                }).then(resp=> {
                    if (resp.status == 200) {
                        //成功
                        var respData = resp.data;
                        if (200 == respData.status) {
                            this.onlineUserList = respData.data;
                        } else {
                            this.onlineUserList = [];
                        }
                    } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!');
                    }
                }, resp=> {
                    Message.error('用户非法⊙﹏⊙∥!');
                });
            },
            searchAllUser() {
                this.searchAllUserVisible = true;
                this.fantasyUserBOList = [];
                //this.userName = "";
                //this.nickName = "";
                var _this = this;
                postRequest('/user/user/searchAllUser', {
                    userName: this.userName,
                    nickName: this.nickName,
                    page: this.curPage,
                    rows: this.size
                }).then(resp=> {
                    if (resp.status == 200) {
                        //成功
                        var respData = resp.data;
                        //console.log(respData)
                        if (respData.total > 0) {
                            this.fantasyUserBOList = respData.list;
                            this.total = respData.total;
                            this.size = respData.pageSize;
                            this.curPage = respData.pageNum;
                        } else {
                            this.fantasyUserBOList = [];
                            this.total = respData.total;
                            this.size = respData.pageSize;
                            this.curPage = respData.pageNum;
                        }
                    } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!');
                    }
                }, resp=> {
                    Message.error('用户非法⊙﹏⊙∥!');
                });
            },
            addFriendById: function(friendId, friendName) {
                postRequest('/mail/friend/add', {friendUserId: friendId}).then(resp => {
                    if (resp.status == 200 && 200 == resp.data.status) {
                        Message.success((resp.data.data || '好友请求已发送') + '：' + friendName);
                    } else {
                        Message.error(resp.data.message || '发送失败');
                    }
                }, () => { Message.error('好友请求发送异常'); });
            },
            // 街道玩家情报卡触发：加好友（id 已由卡片按字符串带过来，避免雪花 ID 精度丢失）
            handleAddFriendEvent: function(payload) {
                if (!payload || !payload.id) return;
                this.addFriendById(payload.id, payload.name || '');
            },
            addFriendByUserName: function(userName) {
                if (!userName || !userName.trim()) {
                    Message.warning('用户名为空');
                    return;
                }
                getRequest('/user/user/getFantasyUserByUserName', {userName: userName}).then(resp => {
                    if (resp.status == 200 && resp.data && resp.data.id) {
                        this.addFriendById(resp.data.id, resp.data.nickName || userName);
                    } else {
                        Message.error('该用户不存在。');
                    }
                }, () => { Message.error('查询用户异常'); });
            },
            whisperTo: function(value) {
                this.chattext = "/" + value + " ";
                this.searchAllUserVisible = false;
                this.searchOnlineUserVisible = false;
                this.whisperUser = value;
                // 移动端来源会先发 openDrawer 拉出侧滑抽屉；v-show 的显示要等下一帧 DOM
                // 更新后才生效，focus 得挂 nextTick，否则对隐藏元素是 no-op
                this.$nextTick(() => {
                    if (this.$refs['chattext']) this.$refs['chattext'].focus();
                });
            },
            checkAndGetDetail: function(value) {
                if (!value || !value.trim()) {
                    Message.warning('请输入要查询的用户名');
                    return;
                }
                this.getDetail(value);
            },
            getDetail: function(value) {
                this.fantasyUser = {};
                this.fantasyUserDetail = {};
                this.fantasyUserHeader = {};
                var _this = this;
                getRequest('/user/user/userDetail', {
                    userName: value
                }).then(resp=> {
                    if (resp.status == 200) {
                        //成功
                        var respData = resp.data;
                        if (200 == respData.status) {
                            this.fantasyUser = respData.data.fantasyUser;
                            if (!this.fantasyUser || !this.fantasyUser.userName) {
                                this.fantasyUser = {};
                                this.fantasyUserDetail = {};
                                this.fantasyUserHeader = {};
                                Message.error('未查询到该用户信息');
                                return;
                            }
                            this.userDetailVisible = true;
                            if (null != respData.data.fantasyUserDetail) {
                                this.fantasyUserDetail = respData.data.fantasyUserDetail;
                            } else {
                                this.fantasyUserDetail = {};
                            }
                            if (null != respData.data.userHeader) {
                                this.fantasyUserHeader = respData.data.userHeader;
                                this.$nextTick(()=>{
                                    try {
                                        if (_this.fantasyUserHeader.mouthUrl && _this.$refs.mouth_type) _this.$refs.mouth_type.style.backgroundImage = "url(" + _this.ossPath + _this.fantasyUserHeader.mouthUrl + ")";
                                        if (_this.fantasyUserHeader.faceUrl && _this.$refs.header_type) _this.$refs.header_type.style.backgroundImage = "url(" + _this.ossPath + _this.fantasyUserHeader.faceUrl + ")";
                                        if (_this.fantasyUserHeader.eyeUrl && _this.$refs.eye_type) _this.$refs.eye_type.style.backgroundImage = "url(" + _this.ossPath + _this.fantasyUserHeader.eyeUrl + ")";
                                        if (_this.fantasyUserHeader.hairUrl && _this.$refs.hair_type) _this.$refs.hair_type.style.backgroundImage = "url(" + _this.ossPath + _this.fantasyUserHeader.hairUrl + ")";
                                    } catch (e) {}
                                })
                            } else {
                                this.fantasyUserHeader = {};
                                this.$nextTick(()=>{
                                    try {
                                        if (_this.$refs.mouth_type) _this.$refs.mouth_type.style.backgroundImage = "";
                                        if (_this.$refs.header_type) _this.$refs.header_type.style.backgroundImage = "";
                                        if (_this.$refs.eye_type) _this.$refs.eye_type.style.backgroundImage = "";
                                        if (_this.$refs.hair_type) _this.$refs.hair_type.style.backgroundImage = "";
                                    } catch (e) {}
                                })
                            }
                        } else {
                            this.fantasyUser = {};
                            this.fantasyUserDetail = {};
                            this.fantasyUserHeader = {};
                            this.$nextTick(()=>{
                                try {
                                    if (_this.$refs.mouth_type) _this.$refs.mouth_type.style.backgroundImage = "";
                                    if (_this.$refs.header_type) _this.$refs.header_type.style.backgroundImage = "";
                                    if (_this.$refs.eye_type) _this.$refs.eye_type.style.backgroundImage = "";
                                    if (_this.$refs.hair_type) _this.$refs.hair_type.style.backgroundImage = "";
                                } catch (e) {}
                            });
                            Message.error(respData.message);
                        }
                    } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!');
                    }
                }, resp=> {
                    Message.error('用户非法⊙﹏⊙∥!');
                });
            },
            disconnect: function() {
                if(this.stomp != null && this.stomp.connected){
                    this.stomp.disconnect();
                    console.log("Disconnected");
                }
                this.stomp = null;
                this._connecting = false;
                if (this._socket) {
                    try { this._socket.close(); } catch (e) {}
                    this._socket = null;
                }
            },
    connect: function(currentUser) {
        let _this = this;
        if (currentUser && this.currentUser == null) {
            this.currentUser = currentUser;
        }
        if (this.currentUser == null) {
            return ;
        }
        // 避免重复连接
        if (this.stomp && this.stomp.connected) {
            return;
        }
        // 握手进行中不允许重入：connected 要等握手完成才为 true，慢网下这个窗口
        // 有好几秒，期间 currentUser 事件（每次移动都会发）再触发 connect 会把
        // 同一段「离线区间」历史再拉一遍（聊天区内容翻倍）
        if (this._connecting) {
            return;
        }
        this._connecting = true;
        // 防止重连时 socket 一直增长
        if (this._socket) {
            try { this._socket.close(); } catch (e) {}
        }
        let socket = new SockJS(chatUrl + '/webSocketServer', null, {
            transports: ['websocket', 'xhr-streaming', 'xhr-polling']
        });
        this._socket = socket;
        this.stomp = Stomp.over(socket);
        let stompClient = this.stomp;
        this.stomp.connect(
            {
                name: this.currentUser.id, // 携带客户端信息
                Authorization: 'Bearer ' + this.cookies.get('accessToken') // 携带JWT token用于认证
            },
            function () {
                // 迟到的旧握手回调：连接已被重连换掉，不能再订阅，否则同一连接上
                // 会挂两份订阅、实时消息翻倍
                if (_this.stomp !== stompClient) {
                    return;
                }
                _this._connecting = false;
                //发送给指定用户的，都需要以/user开头
                stompClient.subscribe("/trade/getResponse", _this.tradeHandleNotification);
                stompClient.subscribe("/user/whisper/getResponse", _this.whisperHandleNotification);
                stompClient.subscribe("/user/city/getResponse", _this.cityHandleNotification);
                stompClient.subscribe("/world/getResponse", _this.worldHandleNotification);
                stompClient.subscribe("/system/getResponse", _this.systemHandleNotification);
                stompClient.subscribe("/user/system/getResponse", _this.userSystemHandleNotification);
                stompClient.subscribe("/rolling/getResponse", _this.rollerMessageHandleNotification);
                stompClient.subscribe("/user/chatMovement/getResponse", _this.chatMovementHandleNotification);
            },
            function (err) {
                // 握手失败也要放行，否则后续 connect 全被 _connecting 挡死
                _this._connecting = false;
            });
        // 拉历史前先清空四频道并升批次号：connect 被再次触发（重连）时若不清空，
        // 同一段「离线区间」会被追加成两份；批次号用来丢弃慢网上迟到的旧响应
        this._historyLoadId = (this._historyLoadId || 0) + 1;
        this.cityContent = "";
        this.worldContent = "";
        this.tradeContent = "";
        this.whisperContent = "";
        // 加载离线期间消息
        _this.loadCityMsg(_this.currentUser.id);
        _this.loadWorldMsg(_this.currentUser.id);
        _this.loadTradeMsg(_this.currentUser.id);
        _this.loadWhisperMsg(_this.currentUser.id);
    },
            /**
             * 所属城市变化（王都 ⇄ 幻之都）。
             *
             * 后端已按「当前位置」隔离城市频道：跨城后只会收到新城市的消息、历史也只取新城市。
             * 但聊天区是常驻组件，切换场景不会重连，旧的聊天记录会留在框里 ——
             * 表现为「站在幻之都，上面还挂着王都的聊天」，所以这里在跨城时清空并重拉。
             *
             * 同一城市内走动（每次 moveTo 都会发 cityInfo）不做任何处理。
             */
            onCityInfo: function(info) {
                if (!info) {
                    return;
                }
                var cityId = (info.city && info.city.id != null) ? String(info.city.id) : '';
                if (!cityId) {
                    cityId = (info.cityMap && info.cityMap.cityid != null) ? String(info.cityMap.cityid) : '';
                }
                if (!cityId) {
                    return;
                }
                var cityName = (info.city && info.city.cityname) ? String(info.city.cityname) : '';
                // 首次拿到城市：历史已由 connect() 按当前城市拉取过，只记录不重置
                if (this._cityId == null) {
                    this._cityId = cityId;
                    return;
                }
                if (this._cityId === cityId) {
                    return;
                }
                this._cityId = cityId;
                // 跨城：清空城市频道，只保留切换之后新城市里的消息
                this._historyLoadId = (this._historyLoadId || 0) + 1;
                this.cityContent = "";
                if (cityName) {
                    this.cityContent = "<span class='system'>【系统】已进入" + this.escapeHtml(cityName)
                        + "，切换至本城频道。</span><br/>";
                }
                if (this.currentUser) {
                    this.loadCityMsg(this.currentUser.id, Date.now());
                }
            },
            // 城市名直接拼进 v-html，做最小转义
            escapeHtml: function(text) {
                return String(text)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');
            },
            loadCityMsg: function(userId, since) {
                var loadId = this._historyLoadId;
                var params = {userId: userId};
                // since（毫秒）：跨城切频道时传切换时刻，只要新城市在此之后的消息；
                // 不传则后端沿用「上次离线时间」的旧口径
                if (since) {
                    params.since = since;
                }
                postRequest('/chat/historyMsg/getCityMsgList', params).then(resp=> {
                    if (loadId !== this._historyLoadId) return; // 迟到的旧响应，已被新加载批次取代
                    if (resp.status == 200) {
                        //成功
                        var respData = resp.data;
                        //console.log(resp)
                        if (null != respData) {
                            for (var i=0; i<respData.length; i++) {
                                // 历史里的系统消息（如整点报时、登录欢迎语）会自带【系统】前缀，
                                // 早期实现把 cls 写死成 city，导致刷新后系统消息退化成普通聊天气泡
                                var cls = respData[i].startsWith("【系统】") ? "system" : "city";
                                var styleMsg = "<span class='" + cls + "'>" + respData[i] + "</span><br/>";
                                this.cityContent = this.cityContent + styleMsg;
                            }
                            //this.keepBottomAll();
                        }
                    } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!1');
                    //this.$router.replace({path: '/'});
                    }
                }, resp=> {
                    Message.error('用户非法⊙﹏⊙∥!2');
                });
            },
            loadWorldMsg: function(userId) {
                var loadId = this._historyLoadId;
                postRequest('/chat/historyMsg/getWorldMsgList', {
                    userId: userId
                }).then(resp=> {
                    if (loadId !== this._historyLoadId) return; // 迟到的旧响应，已被新加载批次取代
                    if (resp.status == 200) {
                        //成功
                        var respData = resp.data;
                        if (null != respData) {
                            for (var i=0; i<respData.length; i++) {
                                var styleMsg = "<span class='world'>" + respData[i] + "</span><br/>";
                                this.worldContent = this.worldContent + styleMsg;
                            }
                            //this.keepBottomAll();
                        }
                    } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!1');
                    //this.$router.replace({path: '/'});
                    }
                }, resp=> {
                    Message.error('用户非法⊙﹏⊙∥!2');
                });
            },
            loadTradeMsg: function(userId) {
                var loadId = this._historyLoadId;
                postRequest('/chat/historyMsg/getTradeMsgList', {
                    userId: userId
                }).then(resp=> {
                    if (loadId !== this._historyLoadId) return; // 迟到的旧响应，已被新加载批次取代
                    if (resp.status == 200) {
                        //成功
                        var respData = resp.data;
                        if (null != respData) {
                            for (var i=0; i<respData.length; i++) {
                                var styleMsg = "<span class='trade'>" + respData[i] + "</span><br/>";
                                this.tradeContent = this.tradeContent + styleMsg;
                            }
                            //this.keepBottomAll();
                        }
                    } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!1');
                    //this.$router.replace({path: '/'});
                    }
                }, resp=> {
                    Message.error('用户非法⊙﹏⊙∥!2');
                });
            },
            loadWhisperMsg: function(userId) {
                var loadId = this._historyLoadId;
                postRequest('/chat/historyMsg/getWhisperMsgList', {
                    userId: userId
                }).then(resp=> {
                    if (loadId !== this._historyLoadId) return; // 迟到的旧响应，已被新加载批次取代
                    if (resp.status == 200) {
                        //成功
                        var respData = resp.data;
                        if (null != respData) {
                            for (var i=0; i<respData.length; i++) {
                                var styleMsg = "<span class='whisper'>" + respData[i] + "</span><br/>";
                                this.whisperContent = this.whisperContent + styleMsg;
                                this.cityContent = this.cityContent + styleMsg;
                            }
                            //this.keepBottomAll();
                        }
                    } else {
                    //失败
                    Message.error('用户非法⊙﹏⊙∥!1');
                    //this.$router.replace({path: '/'});
                    }
                }, resp=> {
                    Message.error('用户非法⊙﹏⊙∥!2');
                });
            },
            lockit: function() {
                //锁定滚动条，不再自动滚动到最底部
                if (this.lockScroll == false) {
                    this.lockScroll = true;
                    this.lockStr = "解";
                    this.lockClass = 'select';
                } else {
                    this.lockScroll = false;
                    this.lockStr = "锁";
                    this.lockClass = '';
                    this.keepBottom($('#con li.show'));
                }
            },
            //切换聊天窗口
            titit: function(tab) {
                this.currentTab = tab;
                var i = this.tabs.indexOf(tab);
                $('#con li').eq(i).show().siblings().hide();
                this.keepBottom($('#con li').eq(i));
            },

            //保持滚动条在最底部
            // keepBottomAll: function() {
            //     this.keepBottom(this.$refs.city);
            //     this.keepBottom(this.$refs.world);
            //     this.keepBottom(this.$refs.trade);
            //     this.keepBottom(this.$refs.whisper);
            // },
            keepBottom: function(element) {
                if (this.lockScroll == false && element) {
                    try {
                        element.scrollTop = element.scrollHeight;
                    } catch (e) {}
                }
            },
            //根据消息类型，获取间隔时间
            getTalksTime: function(msgType) {
                var TALKS_WORLD_TIME = 60*1000;
                var TALKS_CITY_TIME = 5*1000;
                var TALKS_TRADE_TIME = 5*1000;
                var TALKS_WHISPER_TIME = 5*1000;
                var talksTime = TALKS_WORLD_TIME;
                if (msgType == "城市") {
                    talksTime = TALKS_CITY_TIME;
                } else if (msgType == "世界") {
                    talksTime = TALKS_WORLD_TIME;
                } else if (msgType == "交易") {
                    talksTime = TALKS_TRADE_TIME;
                } else if (msgType == "私聊") {
                    talksTime = TALKS_WHISPER_TIME;
                }
                return talksTime;
            },
            //接收城市频道消息，并切换到城市频道
            cityHandleNotification: function(message) {
                var cls = "";
                if (message.body.startsWith("【系统】") == true) {
                    cls = "system";
                } else {
                    cls = "city";
                }
                var styleMsg = "<span class='" + cls + "'>" + message.body + "</span><br/>";
                // 只吞「重连欢迎语」：后端 connect() 每次重连都推一次【系统】欢迎来到幻之大地，
                // 聊天框已有内容时它纯属噪音。旧实现写的是「cityContent 非空 + 是系统消息」就丢，
                // 结果把整点报时、建设投料播报等所有实时系统消息一起吞了（只能靠刷新看历史）。
                if (this.cityContent!="" && cls=="system"
                    && message.body.indexOf("欢迎来到幻之大地") >= 0) {
                    console.log("重连聊天服务器成功。");
                } else {
                    this.cityContent = this.cityContent + styleMsg;
                }
                //alert($("#city").scrollTop)
                //alert($("#city").scrollHeight)
                //this.keepBottomAll();
            },
            //接收世界频道消息，并切换到世界频道
            worldHandleNotification: function(message) {
                var styleMsg = "<span class='world'>" + message.body + "</span><br/>";
                //$("#world").append(styleMsg).append("<br/>");
                this.worldContent = this.worldContent + styleMsg;
                //this.keepBottomAll();
                //this.keepBottom($('#world'));
            },
            //接收交易频道消息，并切换到交易频道
            tradeHandleNotification: function(message) {
                var styleMsg = "<span class='trade'>" + message.body + "</span><br/>";
                //$("#trade").append(styleMsg).append("<br/>");
                this.tradeContent = this.tradeContent + styleMsg;
                //this.keepBottomAll();
                //keepBottom($('#trade'));
            },
            //接收私聊频道消息
            whisperHandleNotification: function(message) {
                var styleMsg = "<span class='whisper'>" + message.body + "</span><br/>";
                //$("#whisper").append(styleMsg).append("<br/>");
                //$("#city").append(styleMsg).append("<br/>");
                this.whisperContent = this.whisperContent + styleMsg;
                this.cityContent = this.cityContent + styleMsg;
                //this.keepBottomAll();
                //keepBottom($('#whisper'));
            },
            //接收系统频道消息
            systemHandleNotification: function(message) {
                console.log(message)
                var styleMsg = "<span class='system'>" + message.body + "</span><br/>";
                //$("#system").append(styleMsg).append("<br/>");
                this.systemContent = this.systemContent + styleMsg;
                //this.keepBottomAll();
                //keepBottom($('#system'));
            },
            userSystemHandleNotification: function(message) {
                console.log(message)
                var styleMsg = "<span class='system'>" + message.body + "</span><br/>";
                //$("#system").append(styleMsg).append("<br/>");
                this.systemContent = this.systemContent + styleMsg;
                //this.keepBottomAll();
                //keepBottom($('#system'));
            },
            rollerMessageHandleNotification: function(message) {
                this.$root.eventHub.$emit("rollerMessage", message.body);
            },
            //接收聊天动作消息，并切换到城市频道
            chatMovementHandleNotification: function(message) {
                var styleMsg = "<span class='system'>" + message.body + "</span><br/>";
                this.cityContent = this.cityContent + styleMsg;
            },
            sendSpittle: function(msgType, text) {
                if (msgType == "城市") {
                    this.stomp.send("/city", {cityId:1}, text);
                } else if (msgType == "世界") {
                    this.stomp.send("/world", {}, text);
                } else if (msgType == "交易") {
                    this.stomp.send("/trade", {}, text);
                } else if (msgType == "私聊") {
                    this.stomp.send("/whisper", {}, text);
                }
            },
            talk: function() {
                var text = $("#text").val()//.replace(/[~'!<>@#$%^&*()-+_=:]/g, "");
                var msgType = $("#msgType").val();
                var talksTime = this.getTalksTime(msgType);
                if (msgType=="世界" && this.talkableWorld==false
                || msgType=="城市" && this.talkableCity==false
                || msgType=="交易" && this.talkableTrade==false
                || msgType=="私聊" && this.talkableWhisper==false
                ) {
                    Message.warning("请等待" + talksTime/1000 + "秒钟再发送消息。");
                    $("#text").focus();
                    return false;
                }

                if (text == "") {
                    Message.warning("信息不能为空！");
                    return false;
                }
                if (text.length > 200) {
                    Message.warning("信息过长，请分割后发送！");
                    return false;
                }
                //如果消息是以/开头的话，可能是私聊信息，切换类型到私聊
                if (text.indexOf("/") == 0) {
                    $("#msgType").val("私聊");
                    msgType = $("#msgType").val();
                    this.chattext = "/" + this.whisperUser + " ";
                } else {
                    this.chattext = "";
                }

                this.sendSpittle(msgType, text);
                this.$refs['chattext'].focus();
                //$("#text").val("");
                //$("#text").focus();


                var self = this;
                if (msgType=="世界") {
                    this.talkableWorld = false;
                } else if (msgType=="城市") {
                    this.talkableCity = false;
                } else if (msgType=="交易") {
                    this.talkableTrade = false;
                } else if (msgType=="私聊") {
                    this.talkableWhisper = false;
                }
                function recover() {
                    if (msgType=="世界") {
                        self.talkableWorld = true;
                    } else if (msgType=="城市") {
                        self.talkableCity = true;
                    } else if (msgType=="交易") {
                        self.talkableTrade = true;
                    } else if (msgType=="私聊") {
                        self.talkableWhisper = true;
                    }
                }
                this.timer1 = setTimeout(recover, talksTime)
                //setInterval(recover, talksTime);
            },
            changeMsgType: function() {
                var msgType = $("#msgType").val();
                var text = $("#text").val();
                this.$refs['chattext'].focus();
                if ("私聊" != msgType && text.indexOf("/") == 0) {
                    this.chattext = "";
                }
            }
        }   
    }
</script>

<style>
* {
    margin: 0;
    padding: 0;
    list-style: none;
}
#chatWrap {
    width: 100%;
    height: 100%;
    background: #2d2340;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.searchdiv {
    margin: 0 auto;
    text-align: center;
    padding: 8px 0;
    background: transparent;
    border-bottom: 1px solid #5a4f6c;
}
a {
    cursor: pointer;
    color: blue;
}
.searchdiv a {
    cursor: pointer;
    margin: 0 6px;
    padding: 4px 10px;
    color: #d4a574;
    font-size: 12px;
    text-decoration: none;
    border: 1px solid #5a4f6c;
    border-radius: 5px;
    transition: all 0.15s;
    display: inline-block;
}
.searchdiv a:hover {
    color: #fff;
    border-color: #d4a574;
}
/*聊天tab分窗口 begin*/
#con {
    flex: 1;
    min-height: 0;
    margin: 5px auto;
    width: 100%;
    max-width: 255px;
}
#con li{
    display: none;
    height: 100%;
    width: 100%;
    background: #3d3250;
    border: 1px solid #2d2340;
    border-radius: 4px;
    font-size: 14px;
    line-height: 20px;
    overflow: auto;
    box-sizing: border-box;
}
#con li.show {
    display: block;
}
/*不同频道的字体颜色不同*/
#con li span.city{
    color: #ccc;
}
#con li span.world{
    color: #00a4ea;
}
#con li span.trade{
    color: #45ea35;
}
#con li span.whisper{
    color: #c74dea;
}
#con li span.system{
    color: yellow;
}
/*聊天tab分窗口 end*/
/*聊天tab按钮 begin*/
#tit {
    height: auto;
    display: flex;
    align-items: center;
    gap: 2px;
}
#tit span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    line-height: 22px;
    min-width: 22px;
    font-size: 11px;
    text-align: center;
    color: #a89bb8;
    background: #3d3250;
    border: 1px solid #5a4f6c;
    border-radius: 4px;
    cursor: pointer;
    padding: 0 4px;
    transition: all 0.15s;
    float: none;
    margin: 0;
}
#tit span.select {
    background: #6a1b9a;
    color: #fff;
    border-color: #9c27b0;
}
#tit span:hover {
    color: #fff;
    background: #4a3f5c;
}
/*聊天tab按钮 end*/
/*聊天功能按钮区 begin*/
#chatWrap div.func {
    display: flex;
    align-items: center;
    gap: 4px;
    float: none;
}
#chatWrap div.func span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    line-height: 22px;
    min-width: 22px;
    font-size: 11px;
    text-align: center;
    color: #a89bb8;
    background: #3d3250;
    border: 1px solid #5a4f6c;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s;
    float: none;
    margin: 0;
    padding: 0 4px;
}
#chatWrap div.func span.select {
    background: #6a1b9a;
    color: #fff;
    border-color: #9c27b0;
}
#chatWrap div.func span:hover {
    color: #fff;
    background: #4a3f5c;
}
#chatWrap div.func select {
    float: none;
    margin: 0;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 22px;
    padding: 0 18px 0 6px;
    font-size: 11px;
    color: #f0e6d2;
    background-color: #3d3250;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5'%3E%3Cpath d='M0 0l4 5 4-5z' fill='%23d4a574'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 5px center;
    border: 1px solid #5a4f6c;
    border-radius: 4px;
    cursor: pointer;
    outline: none;
}
#chatWrap div.func select:focus {
    border-color: #d4a574;
}
/* 聊天动作图鉴入口：外观与同排的「锁」按钮保持一致，颜色用暖金强调 */
/* 用 button 而非 a：点击是就地开弹窗，不是跳页 */
#chatWrap div.func button.mv-help {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 22px;
    line-height: 22px;
    min-width: 22px;
    padding: 0 5px;
    font-size: 11px;
    font-weight: 700;
    font-family: inherit;
    text-align: center;
    color: #d4a574;
    background: #3d3250;
    border: 1px solid #5a4f6c;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s;
    outline: none;
}
#chatWrap div.func button.mv-help:hover,
#chatWrap div.func button.mv-help:focus {
    color: #fff;
    background: #6a1b9a;
    border-color: #9c27b0;
}
/*聊天功能按钮区 end*/
#text {
    margin: 0;
    flex: 1 1 auto;
    min-width: 0;
    height: 24px;
    font-size: 12px;
}
/* cursor:pointer; */
span.nickname {
	
	/* background:#005fee; */
    color: #00a4ea;
    position:relative;
}

#chatWrap .nickname .opts {
    position:absolute;
    display: none;
    background-color: #aaa;
    z-index: 10;
    width: 50px;
    border:1px solid #f00;
    bottom:10px;
    left:10px;
}
#chatWrap .nickname .opts a {
    display: block;
    padding: 5px;
    margin: auto;
    text-decoration: none;
}
#chatWrap .nickname .opts a:hover {
    text-decoration: underline;
    background-color: #666;
    color: #fff;
}
#chatWrap .nickname:hover .opts {
    display:block;
}
/* 触摸设备：禁用悬浮显示，私聊/情报菜单改由点击昵称切换 */
@media (hover: none) {
    #chatWrap .nickname:hover .opts {
        display: none;
    }
    #chatWrap .nickname .opts {
        bottom: auto;
        top: 22px;
        left: 0;
        width: 64px;
        padding: 2px;
    }
    #chatWrap .nickname .opts a {
        padding: 8px 4px;
        font-size: 13px;
        text-align: center;
    }
}

.searchUserbg {
    width:100%;
    max-height: 85vh;
    overflow-y: auto;
}
.searchUserbg .searchUserTitle {
    padding:3px 5px;
    background-color:#72b653;
    font-size:16px;
    font-weight:bold;
    color:#fff;
    letter-spacing:5px;
    text-align:center;
}
.searchUserbg .fantasyUserBOList {
    padding:5px;
    text-align:center;
}
/* 家中无道具时，提示语显示的样式 */
.searchUserbg .noUser {
    padding:3px 5px;
    font-size:16px;
    font-weight:bold;
    letter-spacing:5px;
    text-align:center;
    height: 100px;
    line-height: 100px;
}
/* 家中道具搜索 */
.userSearch {
    height: 26px;
    line-height: 26px;
    font-size: 16px;
    vertical-align:middle;
    text-align: center;
    margin: 5px;
}
.userSearch input {
    height: 26px;
    width: 100px;
    line-height: 26px;
    vertical-align:middle;
    text-align: center;
}
.fantasyUserBOList .el-row {
    font-size: 16px;
}
.fantasyUserBOList .el-col span {
    height: 40px;
    line-height: 40px;
}
.fantasyUserBOList .el-col img {
    height: 40px;
    line-height: 40px;
}
#chatWrap .detailwrap {
    width: 50%;
}
.detailbg {
    background: #fdffea;
}

/* ── 聊天动作图鉴弹窗（聊天框旁的「?」）──────────────────────────
   标题条沿用本组件既有弹窗的绿底白字（#72b653）观感，内容区复用
   chatMovement/ChatMovementList.vue 的 compact 版；列表数据由该组件
   自己走公开接口 /chat/chatMovement/list 拉取。 */
.mv-dialog.el-dialog {
    border-radius: 10px;
    overflow: hidden;
}
.mv-dialog .el-dialog__body {
    padding: 0 14px 14px;
    background: #f0f2f5;
}
.mv-panel {
    max-height: 72vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.mv-title {
    margin: 0 0 12px;
    padding: 5px 10px;
    background-color: #72b653;
    border-radius: 0 0 6px 6px;
    font-size: 15px;
    font-weight: bold;
    color: #fff;
    letter-spacing: 5px;
    text-align: center;
}
.mv-tip {
    padding: 8px 10px;
    background: #fff;
    border-left: 3px solid #72b653;
    border-radius: 6px;
    font-size: 12px;
    line-height: 1.85;
    color: #606266;
    margin-bottom: 8px;
}
.mv-tip code {
    background: #f5f7fa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 0 4px;
    font-family: Consolas, Menlo, monospace;
    font-size: 11.5px;
    color: #b5610a;
}
.mv-roles {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    background: #fff;
    border-radius: 6px;
    font-size: 12px;
    color: #606266;
    margin-bottom: 8px;
}
.mv-roles label {
    display: flex;
    align-items: center;
    gap: 5px;
}
.mv-roles input {
    width: 88px;
    padding: 3px 8px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    font-size: 12px;
    color: #303133;
    background: #fff;
    outline: none;
}
.mv-roles input:focus {
    border-color: #409eff;
}
.mv-roles .mv-note {
    margin-left: auto;
    color: #c0c4cc;
    font-size: 11px;
}
.mv-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin: 0 2px 10px;
    font-size: 12px;
    color: #909399;
}
.mv-legend i {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 2px;
    margin-right: 5px;
    vertical-align: middle;
}
.detailTitle {
    color: #70afbe;
}
.detailLabel {
    color: #7d7a75;
}
.detailValue {
    color: #92655f;
}

#sangForm {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
}
.chat-controls {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100%;
    flex-shrink: 0;
}
#text {
    flex: 1 1 auto;
    min-width: 0;
    height: 32px;
    font-size: 13px;
    margin: 0;
    padding: 4px 8px;
    color: #f0e6d2;
    background: #3d3250;
    border: 1px solid #5a4f6c;
    border-radius: 4px;
    outline: none;
    box-sizing: border-box;
}
#text:focus {
    border-color: #d4a574;
}
#sangForm .button {
    flex-shrink: 0;
    height: 32px;
    width: 48px;
    font-size: 12px;
    margin: 0;
    color: #fff;
    background: #6a1b9a;
    border: 1px solid #9c27b0;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.15s;
}
#sangForm .button:hover {
    background: #7b1fa2;
}

#header_div {
	width:64px;
	height:80px;
  background-size:64px 80px;
  -moz-background-size:64px 80px;
	position:relative;
}

#header_div #hair_type {
	width:64px;
	height:80px;
	background-size:64px 80px;
	background-repeat:no-repeat;
	position:absolute;
}

#header_div #eye_type {
	width:64px;
	height:80px;
	background-size:64px 80px;
	background-repeat:no-repeat;
	position:absolute;
}

#header_div #mouth_type {
	width:64px;
	height:80px;
	background-size:64px 80px;
	background-repeat:no-repeat;
	position:absolute;
}

#header_div #header_type {
	width:64px;
	height:80px;
	background-size:64px 80px;
	background-repeat:no-repeat;
	position:absolute;
}

/* ===== 移动端：抽屉内紧凑聊天 ===== */
@media (max-width: 768px) {
  #chatWrap {
    height: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  #con li {
    width: 100%;
    height: 100%;
    font-size: 12px;
    line-height: 16px;
    box-sizing: border-box;
  }
  #con {
    flex: 1;
    min-height: 0;
    margin: 2px 0 !important;
  }
  #tit {
    height: auto;
    width: auto;
    display: flex;
    gap: 1px;
  }
  #tit span {
    font-size: 10px;
    height: 20px;
    line-height: 20px;
    min-width: 18px;
    padding: 0 3px;
  }
  #sangForm {
    flex-wrap: wrap !important;
    gap: 3px;
  }
  .chat-controls {
    gap: 2px;
  }
  #text {
    flex: 1 1 auto;
    min-width: 0;
    height: 30px;
    font-size: 11px;
    color: #f0e6d2;
    background: #3d3250;
    border: 1px solid #5a4f6c;
    border-radius: 4px;
    padding: 4px 6px;
    outline: none;
    box-sizing: border-box;
    display: block;
  }
  #sangForm .button {
    flex-shrink: 0;
    height: 30px;
    width: 48px;
    font-size: 12px;
    color: #fff;
    background: #6a1b9a;
    border: 1px solid #9c27b0;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
  }
  #chatWrap div.func select {
    max-width: 62px;
    font-size: 10px;
    height: 20px;
    padding: 0 14px 0 4px;
  }
  #chatWrap div.func select {
    max-width: 62px;
    font-size: 10px;
    height: 20px;
    padding: 0 14px 0 4px;
  }
  #chatWrap div.func span {
    height: 20px;
    line-height: 20px;
    min-width: 18px;
    font-size: 10px;
    padding: 0 3px;
  }
  .searchdiv {
    background: transparent;
    border-bottom-color: #5a4f6c;
  }
  .searchdiv a {
    font-size: 11px;
    margin: 2px 3px;
    padding: 3px 8px;
    color: #d4a574;
    border: 1px solid #5a4f6c;
    border-radius: 4px;
    display: inline-block;
  }
  .searchdiv a:hover {
    color: #fff;
    border-color: #d4a574;
  }
  #sangForm {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 3px;
    width: 100%;
    overflow: hidden;
  }
  #sangForm .func {
    width: auto;
    display: flex;
    align-items: center;
    gap: 3px;
    flex-shrink: 0;
  }
  #tit {
    height: auto;
    width: auto;
    display: flex;
    gap: 1px;
    flex-shrink: 0;
  }
  #sangForm .func select {
    max-width: 70px;
    font-size: 11px;
  }

  /* 用户查询弹窗移动端适配 */
  .searchUserbg {
    height: auto;
    max-height: 60vh;
    overflow-y: auto;
  }
  .searchUserbg .fantasyUserBOList {
    height: auto;
    overflow-y: visible;
  }
  .searchUserbg .fantasyUserBOList .el-row {
    font-size: 13px;
    display: flex;
    align-items: stretch;
  }
  .searchUserbg .fantasyUserBOList .el-row .el-col {
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  .searchUserbg .fantasyUserBOList .el-col span {
    height: auto;
    line-height: 1.4;
    padding: 4px 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
  }
  .searchUserbg .fantasyUserBOList .el-col:nth-child(3) span {
    white-space: normal;
  }
  .userSearch {
    height: auto;
    line-height: 1.4;
    font-size: 13px;
    padding: 6px 4px;
  }
  .userSearch input {
    height: 24px;
    width: 80px;
    line-height: 24px;
    font-size: 13px;
  }

  /* 聊天动作图鉴弹窗移动端：滚动交给 el-dialog__body（App.vue 已全局适配），
     内层不再自己滚，避免嵌套滚动条 */
  .mv-panel {
    max-height: none;
    overflow-y: visible;
  }
  .mv-title {
    font-size: 14px;
  }
  .mv-tip {
    font-size: 11.5px;
    line-height: 1.75;
  }
  .mv-roles .mv-note {
    margin-left: 0;
    width: 100%;
  }
  .mv-legend {
    gap: 10px;
    font-size: 11px;
  }
}
</style>